import { fetchUtils, Options } from 'react-admin';
import { getToken } from '../authentication/authProvider';
import { REACT_APP_API_KEY } from '../lib/constants';

export const httpClient = async (url: string, options: Options = {}) => {
  if (!options.user?.authenticated) {
    const token = await getToken();

    options.user = {
      authenticated: true,
      token: `Bearer ${token}`,
    };
  }
  if (!options.headers) {
    options.headers = new Headers();
  }
  if (options.headers instanceof Headers) {
    options.headers.append('apiKey', REACT_APP_API_KEY as string);
    options.headers.append('Prefer', 'count=exact,return=representation');
  } else {
    (options.headers as Record<string, string>)['apiKey'] = REACT_APP_API_KEY as string;
    (options.headers as Record<string, string>)['Prefer'] =
      'count=exact,return=representation';
  }
  return fetchUtils.fetchJson(url, options);
};

export default httpClient;
